import { Box, Button, Text, VStack, useDisclosure } from '@chakra-ui/react';
import DeleteWholesalerModal from '../components/DeleteWholesalerModal';
import PaymentBannerToggle from './formFields/PaymentBannerToggle';

const WholesalerAdmin = ({ darkMode, resetToMainTable }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <VStack spacing={4} align="stretch">
            <Box
                p={6}
                borderWidth="1px"
                borderRadius="md"
                borderColor={darkMode ? 'gray.600' : 'gray.200'}
                bg={darkMode ? 'black' : 'white'}>
                <VStack spacing={4} align="stretch">
                    <PaymentBannerToggle darkMode={darkMode} />
                </VStack>
            </Box>
            <Box
                p={6}
                borderWidth="1px"
                borderRadius="md"
                borderColor={darkMode ? 'red.600' : 'red.300'}
                bg={darkMode ? 'black' : 'white'}>
                <VStack spacing={4} align="stretch">
                    <Box>
                        <Text
                            fontSize="md"
                            fontWeight="500"
                            mb={2}
                            color={darkMode ? 'white' : 'gray.800'}>
                            Delete
                        </Text>
                        <Text
                            fontSize="sm"
                            color={darkMode ? 'gray.300' : 'gray.700'}
                            mb={3}>
                            By deleting a Wholesaler, invoices will change to
                            finalizing and no further billing will occur
                        </Text>
                        <Button colorScheme="red" onClick={onOpen} size="md">
                            Delete
                        </Button>
                    </Box>
                </VStack>
            </Box>

            <DeleteWholesalerModal
                isOpen={isOpen}
                onClose={onClose}
                resetToMainTable={resetToMainTable}
            />
        </VStack>
    );
};

export default WholesalerAdmin;
